export const BEEKEEPER_CHAT = 'chats_v2';
export const BEEKEEPER_CHAT_BACKEND = 'chats_v2_backend';
export const BEEKEEPER_CHATS = 'beekeeper-chats';
export const SMART_GROUP_CHATS_MANAGEMENT = 'smart_group_chats_management';
